import React from "react";
import styles from "./CustomModal.module.css";
import { ButtonIcon } from "../Button";
import SvgCross from "../../../assets/Cross";
import { Modal } from "@mui/material";

const CustomModal = ({
  isOpen,
  onClose,
  header,
  children,
  footer,
  width = "100%",
  height = "",
  maxWidth = "100%",
  maxHeight = "90vh",
  containerClass = "",
  bodyClass = "",
  footerClass = "",
  headerPosition = "start", //default start, accepted values center, end, start
  headerClass = "heading-l",
  gap = "gap-2xl",
  isLeftAligned = false,
  headerButton,
  disableOutsideClick = false, // when it's true when clicking outside the modal will not close the modal
  isScrollable = true,
}) => {
  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      open={isOpen}
      // onClose={onClose}
      onClose={(event, reason) => {
        if (disableOutsideClick && reason === "backdropClick") return;
        onClose();
      }}
    >
      <div
        className={`${styles.container} w-full rounded-l ${containerClass}`}
        style={{
          width,
          height,
          maxWidth,
          maxHeight,
          backgroundColor: "",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className={`${styles.body} flex flex-col`}
          style={{ flex: 1, minHeight: 0, overflow: "hidden" }}
        >
          <div
            className={`${styles.header} flex items-center self-stretch flex-shrink-0`}
          >
            {headerButton && headerButton}
            <div
              className={`${styles.crossButton} ${
                isLeftAligned ? styles.crossButtonLeft : styles.crossButtonRight
              } flex justify-center items-center rounded-s`}
            >
              <ButtonIcon
                size="m"
                type="white"
                rounded="default"
                icon={<SvgCross fill="#646464" height={20} width={20} />}
                onClick={onClose}
              />
            </div>
          </div>
          <div
            className={`${styles.main} flex px-4xl py-xl `}
            style={{ flex: 1, minHeight: 0, overflow: "hidden" }}
          >
            <div
              className={`${styles.innerContainer} flex flex-col ${gap}`}
              style={{ flex: 1, minHeight: 0 }}
            >
              {header && (
                <div
                  className={`${headerClass}`}
                  style={{ textAlign: headerPosition, flexShrink: 0 }}
                >
                  {header}
                </div>
              )}
              <div
                className={`flex flex-col ${bodyClass} ${isScrollable ? "custom-scrollbar" : ""}`}
                style={{ flex: 1, minHeight: 0, overflowY: isScrollable ? "auto" : "hidden", overflowX: "hidden" }}
              >
                {children}
              </div>
            </div>
          </div>
        </div>

        {footer && (
          <div
            className={`${styles.footer} flex items-center self-stretch rounded-l px-m ${footerClass}`}
            style={{ flexShrink: 0}}
          >
            {footer}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CustomModal;
